import { UtilsState } from "./_types";

export const state: UtilsState = {
    reservations: {
        selectedVehicleId: null
    }
} 